import React from "react";
import { Account, SubmissionType } from "../../generated/graphql";
import { spacing } from "../../stitches.config";
import { FlexColumn, FlexRow } from "../Common/__styles__/Layout";
import { AccountLogo } from "../Common/AccountLogo";
import { Body, Title } from "../Common/Typography";
import { ObjectDisplay } from "./__styles__/Submission";
import { VisibilityPill } from "./VisibilityPill";

type SubmissionHeaderProps = {
  account: Pick<Account, "logoUrl" | "name">;
  objectDisplay?: string;
  submissionType: Pick<SubmissionType, "name">;
  hiddenFromPublic: boolean;
};

const SubmissionHeader: React.FC<SubmissionHeaderProps> = ({
  account,
  objectDisplay,
  submissionType,
  children,
  hiddenFromPublic,
}) => {
  const address =
    objectDisplay ? <ObjectDisplay>{objectDisplay}</ObjectDisplay> : null;

  return (
    <FlexRow>
      <FlexColumn>
        {account.logoUrl && (
          <AccountLogo
            account={account}
            displayPrintOnly={true}
            style={{ marginRight: "16px" }}
          />
        )}
      </FlexColumn>
      <FlexColumn style={{ gap: `${spacing.m}` }}>
        <FlexColumn style={{ gap: `${spacing.s}` }}>
          <Title size="small" type="semiBold" color="contentPrimary">
            {submissionType.name}
          </Title>
          {address && (
            <Body size="default" type="regular" color="contentSecondary">
              {address}
            </Body>
          )}
          {children}
        </FlexColumn>
        <VisibilityPill hiddenFromPublic={hiddenFromPublic} />
      </FlexColumn>
    </FlexRow>
  );
};

export default SubmissionHeader;
